import { render } from "./CreateLab.vue?vue&type=template&id=01193706"
import script from "./CreateLab.vue?vue&type=script&lang=js"
export * from "./CreateLab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__